import { useMerchant } from "@/hooks/useMerchant";
import { useTRPC } from "@/trpc/client";
import type { RentalsMerchantPortalRouterInputs } from "@/trpc/client";
import { useMutation } from "@tanstack/react-query";

export type TopUpBank =
  RentalsMerchantPortalRouterInputs["topUps"]["create"]["bank"];

export function useCreateTopUp() {
  const { merchant } = useMerchant();
  const trpc = useTRPC();

  const createTopUpMutation = useMutation(trpc.topUps.create.mutationOptions());

  const createTopUp = (amount: number, bank: TopUpBank, batchId?: string) => {
    if (!merchant?.id) throw new Error("Merchant not selected");
    return createTopUpMutation.mutateAsync({
      rentalsMerchantId: merchant.id,
      amount,
      bank,
      batchId,
    });
  };

  return { createTopUp, isCreating: createTopUpMutation.isPending };
}
